import { render, staticRenderFns } from "./editResume.vue?vue&type=template&id=5ae0b5a9&scoped=true&"
import script from "./editResume.vue?vue&type=script&lang=js&"
export * from "./editResume.vue?vue&type=script&lang=js&"
import style0 from "./editResume.vue?vue&type=style&index=0&id=5ae0b5a9&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ae0b5a9",
  null
  
)

export default component.exports